import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CourierWorkload" }
const _hoisted_2 = { class: "flex items-center justify-between text-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "-", -1)
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "bg-gray-200 h-1 rounded w-full overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.carOccupancy.title), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.lineClasses, "h-full"]),
          style: _normalizeStyle({ width: `${_ctx.carOccupancy.percent}%`})
        }, null, 6)
      ])
    ])
  ]))
}